import { userService } from "../services";
import config from "../config/config";

export const VendorAction = {
  fetchVendorList,
  saveUser,
  fetchById,
  userActiveInactive,
  updateUser,
  vehicleTypeList,
  disEngageVehicle,
  getOldReportData,
};

async function fetchVendorList(payload) {
  try {
    let data = {
      companyId: payload.companyId,
      name: payload.name,
      companyName: payload.companyName,
      isActive: payload.isActive,
      siteIds: payload.siteIds,
      userId: payload.userId,
    };

    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.VendorList}?pageSize=${payload.pageSize}&pageNo=${payload.pageNo}`;

    //debugger
    let response = await userService.post(apiEndpoint, data);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      // alert(response.data.message);

      // if (response.status != 500) {
      //     // alert(response.data.message);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function updateUser(payload) {
  console.log(payload);
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.UpdateVendor}`;
    // let data = new FormData();
    // data.append('name', payload.name);
    // data.append('gender', payload.gender);
    // data.append('id', payload.id);
    // data.append('phoneNumber', payload.phoneNumber);
    // data.append('designation', payload.designation);
    // data.append('address', payload.address);
    // data.append('updatedBy', payload.updatedBy);
    // data.append('company', payload.company);
    // data.append('file', payload.file);
    // data.append('isActive', payload.isActive);

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      // if (response.status != 500) {
      //     // alert(response.data.message);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function saveUser(payload) {
  console.log(payload);
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.AddVendor}`;
    // let data = new FormData();

    // data.append('name', payload.name);
    // data.append('employeeCode', payload.employeeCode);
    // data.append('gender', payload.gender);
    // data.append('email', payload.email);
    // data.append('phoneNumber', payload.phoneNumber);
    // data.append('designation', payload.designation);
    // data.append('address', payload.address);
    // data.append('createdBy', payload.createdBy);
    // data.append('company', payload.company);
    // data.append('file', payload.file);

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 201) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      // if (response.status != 500) {
      //     return response;
      //     // alert(response.data.responseDescription);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     alert(response.data.responseDescription);
      //     // return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function userActiveInactive(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.ActiveVendor}`;

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      // if (response.status != 500) {
      //     return response;
      //     // alert(response.data.responseDescription);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     alert(response.data.responseDescription);
      //     // return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchById(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.VendorById}?id=${payload.userId}&companyId=${payload.companyId}&userId=${payload.user}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      // if (response.status != 500) {
      //     return response;
      //     // alert(response.data.responseDescription);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     alert(response.data.responseDescription);
      //     // return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function vehicleTypeList(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.VehicleTypeList}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.data.message);

      // if (response.status != 500) {
      //     return response;
      //     // alert(response.data.responseDescription);
      // } else
      // if (response.status == 401) {
      //     alert(response.data.message);
      // } else {
      //     alert(response.data.responseDescription);
      //     // return (response);
      // }
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function disEngageVehicle(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.disengageVehicle}`;
    let response = await userService.post(apiEndpoint, payload);

    if (response && response.status === 200) {
      return response.data;
    } else {
      console.log(response);
      alert(response.responseDescription);

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function getOldReportData(payload) {
  try {
    let apiEndpoint = `${JSON.parse(localStorage.getItem("config")).baseUrl}${config.apiName.oldReportData}`;
    let response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      console.log("hhhh", response);
      alert(response.data.message);

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
